import { createSlice } from "@reduxjs/toolkit";

import {
  usersOverview,
  orgEnabledSensors,
} from "../../actions/users/usersData";

const initialState = {
  usersSummary: {},
  usersDataLoading: false,
  enabledSensors: [],
  enabledSensorsLoading: false,
};

export const usersSummarySlice = createSlice({
  name: "usersSummary",
  initialState,
  reducers: {},
  extraReducers: {
    [usersOverview.pending]: (state) => {
      state.usersDataLoading = true;
    },
    [usersOverview.fulfilled]: (state, { payload }) => {
      state.usersSummary = payload;
      state.usersDataLoading = false;
    },
    [usersOverview.rejected]: (state) => {
      state.usersDataLoading = false;
    },
    [orgEnabledSensors.pending]: (state) => {
      state.enabledSensorsLoading = true;
    },
    [orgEnabledSensors.fulfilled]: (state, { payload }) => {
      state.enabledSensorsLoading = false;
      state.enabledSensors = payload;
    },
    [orgEnabledSensors.rejected]: (state, { payload }) => {
      state.enabledSensorsLoading = false;
      state.enabledSensors = [];
    },
  },
});

export const { userdetails } = usersSummarySlice.actions;

export default usersSummarySlice.reducer;
